import { onMounted, onUnmounted } from "vue";

export function useBeforeUnload(params: {
  showConfirmation?: () => boolean;
  message?: string;
}) {
  const message = params.message || "Changes you made may not be saved.";
  const showConfirmation = () =>
    params.showConfirmation ? params.showConfirmation() : false;

  onMounted(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
  });

  onUnmounted(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
  });

  function handleBeforeUnload(e) {
    if (showConfirmation()) {
      e.preventDefault();
      return (e.returnValue = message);
    }
  }
}
